__turbopack_context__.v({
  "list_mortgage": "page-module-scss-module__H_lZWW__list_mortgage",
  "scrollButton": "page-module-scss-module__H_lZWW__scrollButton",
  "section_calculator": "page-module-scss-module__H_lZWW__section_calculator",
  "section_title": "page-module-scss-module__H_lZWW__section_title",
});
